<h2>Nutzer anlegen</h2>

<ng-container *ngIf="newUser">
  <mat-card>Der Benutzer wurde erfolgreich erstellt. Die neue Benutzer-ID lautet: <strong>{{newUser.id}}</strong></mat-card>
</ng-container>

<form [formGroup]="user">
  <mat-grid-list cols="6" rowHeight="100px">

    <mat-grid-tile colspan="3">
      <mat-form-field appearance="outline">
        <mat-label>Anrede</mat-label>
        <mat-select required formControlName="salut">
          <mat-option value="Herr">Herr</mat-option>
          <mat-option value="Frau">Frau</mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="3">
      <mat-slide-toggle
        formControlName="requireConfirmation"
        [checked]="requireConfirmation">
        E-Mail-Bestätigung anfordern
      </mat-slide-toggle>
    </mat-grid-tile>

    <mat-grid-tile colspan="6">
      <mat-form-field appearance="outline">
        <mat-label>Vorname</mat-label>
        <input required matInput formControlName="given_name">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="6">
      <mat-form-field appearance="outline">
        <mat-label>Nachname</mat-label>
        <input required matInput formControlName="family_name">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="6">
      <mat-form-field appearance="outline">
        <mat-label>E-Mail</mat-label>
        <input required type="email" matInput formControlName="email">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="6">
      <mat-form-field appearance="outline">
        <mat-label>Passwort</mat-label>
        <input matInput formControlName="password">
        <mat-hint>Das Passwort kann nur gespeichert werden, wenn keine E-Mail-Bestätigung erforderlich ist.</mat-hint>
      </mat-form-field>
    </mat-grid-tile>

    <ng-container mat-dialog-actions>
      <mat-grid-tile colspan="3">
        <div class="button-field">
          <button (click)="save()" mat-raised-button color="accent">Speichern
            <mat-icon mat-list-icon>save</mat-icon>
          </button>
        </div>
      </mat-grid-tile>

      <mat-grid-tile colspan="3">
        <div class="button-field" >
          <button mat-raised-button [mat-dialog-close] mat-button>Schließen
            <mat-icon mat-list-icon>close</mat-icon>
          </button>
        </div>
      </mat-grid-tile>
    </ng-container>

  </mat-grid-list>

</form>
